import { render, staticRenderFns } from "./InTour.vue?vue&type=template&id=3464e203&scoped=true&"
import script from "./InTour.vue?vue&type=script&lang=js&"
export * from "./InTour.vue?vue&type=script&lang=js&"
import style0 from "./InTour.vue?vue&type=style&index=0&id=3464e203&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3464e203",
  null
  
)

export default component.exports